//Libraries
import styled from 'styled-components'

// Custom
import LogoFullDark from 'images/logos/heedsLogoFullDark.png'
import LogoFullLight from 'images/logos/heedsLogoFullLight.png'
import MinimalPrimary from 'images/logos/minimalLogoPrimary.png'
import MinimalWhite from 'images/logos/minimalLogoWhite.png'
import MinimalLightBlue from 'images/logos/minimalLightBlue.png'
import MinimalDarkBlue from 'images/logos/minimalDarkBlue.png'

type LogoProps = {
  dark?: boolean
  color?: 'white' | 'lightBlue' | 'darkBlue'
}

type IconProps = {
  dark?: boolean
  margin?: string
}

export const Logo = styled.div<LogoProps>`
  width: 100px;
  height: 30px;
  background-image: url(${({ dark }) => (dark ? LogoFullDark : LogoFullLight)});
  background-repeat: no-repeat;
  background-size: contain;
  @media screen and (min-width: ${({ theme }) => (theme.breakpoints.desktopMin)}px) {
    width: 140px;
    height: 46px;
    background-size: contain;
  }
`

export const MinimalLogo = styled.div<LogoProps>`
  width: 34px;
  height: 41px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${({ color }) => color === 'white' ? MinimalWhite : color === 'lightBlue' ? MinimalLightBlue : color === 'darkBlue' ? MinimalDarkBlue : MinimalPrimary});
`

export const SocialIcon = styled.img<IconProps>`
  width: 16px;
  margin: ${({ margin }) => margin || 0 }px;
  cursor: pointer;
  :hover {
    filter: invert(${({ dark }) => (dark ? '30%' : '46%')})
      sepia(${({ dark }) => (dark ? '28%' : '19%')})
      saturate(${({ dark }) => (dark ? '522%' : '1084%')})
      hue-rotate(${({ dark }) => (dark ? '195deg' : '196deg')})
      brightness(${({ dark }) => (dark ? '20%' : '92%')})
      contrast(${({ dark }) => (dark ? '97%' : '84%')});
  }
`

export const SocialButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.white01};
  border-radius: 8px;
  border: none;
  cursor: pointer;
`
